import { apiFetch } from "../../../lib/api";

export async function fetchAnnotation(wine: string, tab: string, lang: string): Promise<string> {
  const params = new URLSearchParams({ wine, tab, lang });
  const response = await apiFetch(`/annotations?${params.toString()}`, {}, { auth: false });

  if (!response.ok) {
    throw new Error("Erreur lors du chargement de la note.");
  }

  const data = await response.json();
  return data.note || "";
}

export async function saveAnnotation(wine: string, tab: string, lang: string, note: string): Promise<void> {
  const response = await apiFetch(
    "/annotations",
    {
      method: "PUT",
      body: JSON.stringify({ wine, tab, lang, note }),
    },
    { auth: false }
  );

  if (!response.ok) {
    throw new Error("Erreur lors de la sauvegarde de la note.");
  }
}